async function assignValue(payload, value) {
  try {
    let res = payload.find(x => x.value === value)
    res.selected = true
  }
  catch (e) { console.log(e) }
  return payload
}

export default {
  ping: async() => {
    console.log('COMPUTED PING')
  },

  async rdtStatus({ dispatch }, payload) {
    let status = await dispatch('v4/rdt/status', {}, { root: true })
    try {
      payload.forEach(response => {
        response.selected = response.value === status
      })
    }
    catch (e) { console.log(e) }
    return payload
  },
  async assignFemaleGender({}, payload) {
    return assignValue(payload, 'female')
  },

  async assignYes({}, payload) {
    return assignValue(payload, 'yes')
  },

  async assignNo({}, payload) {
    return assignValue(payload, 'no')
  },

  fillResponseUnknown({}, payload) {
    try {
      if (payload.length === 1) {
        // in this case, there is only one response item so it is a value type panel
        payload[0].unknown = true
      }
      else {
        assignValue(payload, 'unknown');
      }
    }
    catch (e) { console.log(e); }

    return payload;
  },
}
